<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-toolbar flat color="transparent" height="50">
          <h3>Báo cáo quãng đường di chuyển</h3>
          <v-spacer></v-spacer>
          <v-menu
            :close-on-content-click="false"
            v-model="menu1"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              box
              height="40"
              slot="activator"
              v-model="fromTime"
              label="Từ ngày"
              append-icon="event"
              class="date-picker"
            ></v-text-field>
            <v-date-picker
              v-model="fromTime"
              @input="menu1 = false"
              @change="getDailyReportingSubmit()"
            ></v-date-picker>
          </v-menu>&nbsp;&nbsp;
          <v-menu
            :close-on-content-click="false"
            v-model="menu2"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              box
              height="40"
              slot="activator"
              v-model="toTime"
              label="Đến ngày"
              append-icon="event"
              class="date-picker"
            ></v-text-field>
            <v-date-picker
              v-model="toTime"
              @input="menu2 = false"
              @change="getDailyReportingSubmit()"
            ></v-date-picker>
          </v-menu>
        </v-toolbar>
        <v-flex lg12>
          <table-list
            :isLoading="isLoading"
            :headers="headers"
            :datasource="dailyReporting"
            :exportFilename="`Bao_cao_quang_duong_di_chuyen`"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TableList from './components/List';
import * as Utils from '@/utils';
import * as DateTimeUtil from '@/utils/datetime';

export default {
  components: {
    TableList
  },
  data () {
    return {
      isLoading: false,
      menu1: false,
      menu2: false,
      fromTime: DateTimeUtil.addDate(new Date(), -30)
        .toISOString()
        .substr(0, 10),
      toTime: new Date().toISOString().substr(0, 10),
      dailyReporting: [],
      headers: [
        {
          text: 'STT',
          value: 'no'
        },
        {
          text: 'Biển số',
          value: 'plate'
        },
        {
          text: 'Quãng đường (km)',
          value: 'km'
        }
      ]
    };
  },
  computed: {
    ...mapGetters(['vehicles'])
  },
  mounted () {
    if (this.vehicles.length === 0) {
      this.getVehicles().then(res => {
        this.getDailyReportingSubmit();
      });
    } else {
      this.getDailyReportingSubmit();
    }
  },
  methods: {
    ...mapActions(['getDailyReporting', 'getVehicles']),
    getDailyReportingSubmit () {
      this.isLoading = true;
      this.dailyReporting = [];
      this.vehicles.map((vehicle, index) => {
        let data = {
          vehicleIds: [vehicle.id],
          fromTime: DateTimeUtil.convertDateTimeToSecond2010(this.fromTime),
          toTime: DateTimeUtil.convertDateTimeToSecond2010(this.toTime)
        };
        this.getDailyReporting(data).then(res => {
          let distance = 0;
          if (res.reports) {
            res.reports.map(a => {
              distance += a.km;
              return 0;
            });
            let item = {
              no: ++index,
              plate: vehicle.plate,
              km: distance.toFixed(2)
            };
            this.dailyReporting.push(item);
            this.isLoading = false;
          }
        });
        return 0;
      });
    }
  }
};
</script>
<style scoped>
.date-picker {
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/pages/reporting/Daily.vue